import Input from '@components/Input';
import Text from '@components/Text';
import { t } from '@i18n';
import { formatMoney } from '@utils/money';
import { isStripeProvider } from '@utils/provider';

export default function Installments({ valuesRef, plan, refreshHandler, provider }: any) {
  if (isStripeProvider(provider) || valuesRef.current.method !== 'credit' || !plan.installments || plan.installments <= 1) {
    return null;
  }

  const coupon = valuesRef.current.coupon;

  const installmentOptions = plan.installments_list.map((installmentValue: number, i: number) => {
    const installmentNumber = i + 1;

    if (coupon && coupon.percent_off) {
      const discountedInstallment = (installmentValue / (i + 1)) * (1 - coupon.percent_off / 100);

      return {
        label: `${t('common.installmentPrefix', { count: installmentNumber })} ${formatMoney(discountedInstallment, 'BRL')} (${t('checkout.installments.discount', { percent: coupon.percent_off })})`,
        value: installmentNumber.toString(),
      };
    }

    return {
      label: `${t('common.installmentPrefix', { count: installmentNumber })} ${formatMoney(installmentValue / (i + 1), 'BRL')}`,
      value: installmentNumber.toString(),
    };
  });

  return (
    <>
      <Text.h5>{t('checkout.installments.title')}</Text.h5>
      <div className="input-group">
        <Input.Select
          bypassStyles
          placeholder={t('checkout.installments.placeholder')}
          value={valuesRef.current.installments}
          onInput={(value: any) => {
            valuesRef.current.installments = value;
            refreshHandler();
          }}
          options={installmentOptions}
        />
      </div>
    </>
  );
}
